import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import './GroupInvitation.css';
import apiClient from '../../networking/APIClient';
import Input from '../form-elements/input/input';

class GroupInvitation extends Component {
    
    state = {
        name: "",
        token: "",
        errorMsg: "",
        success: false
    };

    componentDidMount() {
        this.parseQuery();
    }

    render() {
        if (this.state.success) {
            return this.renderSuccess();
        } else {
            return this.renderForm();
        }        
    }

    parseQuery() {
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        
        this.setState({
            name: params.get("name"),
            token: params.get("token")
        });        
    }

    renderSuccess() {
        return (
            <div className="group-invitation">
                <h1>Welcome onboard!</h1>
                <p>You have successfully joined <strong>{this.state.name}</strong>.</p>
                <p>Open the PaceUP! app on your app to get started.</p>
            </div>
        );
    }   

    renderForm() {
        return (
            <div className="group-invitation">
                <h1>You have been invited to join {this.state.name}!</h1>

                <form onSubmit={(e) => this.handleSubmit(e)}>

                    {this.state.errorMsg && <p className="error-msg">{this.state.errorMsg}</p>}

                    <p>Accept the invitation by entering your email (the one you used to create your PaceUP account with).</p>

                    <div className="invite_title" >Rejoignez votre groupe</div>
                    <span className="invite_span" >Veuillez ajouter votre adresse mail afin de rejoindre votre groupe (elle doit être la même que celle utilisée lors de la création de votre compte paceUP!).</span><br/>

                    <div className="invite_title line-break" >Tritt deiner Gruppe bei</div>
                    <span className="invite_span" >Füge Deine E-Mail-Adresse hinzu, um Deiner Gruppe beizutreten (die gleiche wie bei der Erstellung Deines paceUP!-Kontos).</span><br/>

                    <div className="invite_title line-break" >Gå med i din grupp</div>
                    <span className="invite_span" >Lägg till din e -postadress för att gå med i din grupp (samma som du använde när du skapade ditt paceUP! -konto).</span>

                    <div className="invite_title line-break" >Você foi convidado a participar!</div>
                    <span className="invite_span" >Para aceitar o convite, digite seu email (o mesmo email que voce usou para criar a sua conta no PaceUP).</span>

                    <div className="invite_title line-break" >¡Únete a tu grupo!</div>
                    <span className="invite_span" >Para aceptar la invitación escribe tu dirección de correo electrónico (la misma que usaste al crear tu cuenta en PaceUP).</span>
                    
                    <Input 
                        label="Email" 
                        type="email" 
                        placeholder="usain@bolt.jm" 
                        onChange={(email) => this.setState({email}) } 
                    />

                    <button className="btn btn-primary" type="submit">Join group</button>

                </form>
            </div>
        );
    }

    async handleSubmit(e) {
        e.preventDefault();        
        if (this.state.email) {
            try {                
                await apiClient.acceptInvitation(this.state.token, this.state.email);
                
                this.setState({
                    errorMsg: null,
                    success: true
                })
            } catch(err) {       
                console.log(err);         
                this.setState({
                    errorMsg: "Failed joining group. Make sure you entered same email you used to signup for PaceUP."
                })
            }
        } else {
            this.setState({errorMsg: "Enter a valid email address"})
        }

    }
}

export default withRouter(GroupInvitation);



// WEBPACK FOOTER //
// ./src/components/group-invitation/GroupInvitation.js